import { Components, Theme } from '@mui/material/styles';

import { errorIcon } from '@/utils/formInputUtil';

export default function MuiTextField(theme: Theme): Components['MuiTextField'] {
  return {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          '&.Mui-error': {
            '::after': {
              content: errorIcon,
              width: '20px',
              height: '20px',
              position: 'absolute',
              right: '12px',
            },
            '&:has(.MuiInputAdornment-positionEnd)::after': { display: 'none' },
          },
        },
      },
    },
  };
}
